export enum Ordering {
    CreatedDesc,
    AlphaAsc,
    AlphaDesc
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/ordering.ts